export const ru = {
  posts: {
    meta: {
      draft: 'Не готов',
      ready: 'Готов к публикации',
      published: 'Опубликован',
      retired: 'Неактуален',
    },
    list: {
      title: 'Посты',
      create: 'Новый пост',
      newTitle: 'Рабочее название',
      newHint: 'Например, имя заведения. Пост создастся черновиком.',
      search: 'Поиск по названию и тексту',
      status: 'Статус',
      allStatuses: 'Все статусы',
      allOfMeta: 'Все в состоянии «{meta}»',
      format: 'Правило оформления',
      allFormats: 'Все правила',
      tag: 'Хештег',
      sort: 'Сортировка',
      sortUpdated: 'Недавно изменённые',
      sortCreated: 'Недавно созданные',
      empty: 'Постов пока нет',
      emptyText: 'Создайте первый пост и прикрепите к нему фото из медиатеки.',
      emptySearch: 'Ничего не найдено',
      inQueue: 'В очереди',
      planned: { one: '{n} запланирована', few: '{n} запланированы', many: '{n} запланировано', other: '{n} запланировано' },
      publishedIn: 'Вышел: {channels}',
      dates: {
        created: 'Создан {date}',
        updated: 'Изменён {date}',
        published: 'Вышел {date}',
        planned: 'Выйдет {date}',
      },
      media: { one: '{n} медиа', few: '{n} медиа', many: '{n} медиа', other: '{n} медиа' },
      linkedTo: 'Связан с записью',
      clearLinked: 'Сбросить',
    },
    editor: {
      back: '← Посты',
      title: 'Рабочее название',
      body: 'Текст поста',
      bodyHint: 'Хештеги — отдельным полем, в подпись они добавятся в конце.',
      tags: 'Хештеги',
      tagsHint: 'Через пробел или запятую, «#» не обязателен.',
      status: 'Статус',
      customFields: 'Поля поста',
      save: 'Сохранить пост',
      saved: 'Пост сохранён',
      deleteConfirm: 'Удалить пост «{title}»?',
      unsaved: 'Есть несохранённые изменения',
      format: 'Правило оформления',
      formatDefault: 'По умолчанию ({name})',
      formatDefaultNone: 'По умолчанию',
      formatHint: 'Как писать текст и хештеги этого поста.',
      notes: 'Заметки',
      notesHint: 'Markdown: откуда взяты факты, открытые вопросы. В подпись не попадают.',
      preview: 'Предпросмотр',
      previewEmpty: 'Пусто',
    },
    formatRules: {
      show: 'Правило «{name}»',
      showDefault: 'Правило «{name}» (по умолчанию)',
      none: 'У блога нет правил оформления. Их задаёт владелец: «Настройки → Правила оформления».',
    },
    formats: {
      title: 'Правила оформления',
      subtitle:
        'Как пишутся посты блога: текст, хештеги, порядок фото, откуда брать факты. Текст правила — инструкция и образец для автора, помощников и ИИ-агентов, подстановки полей нет. Пост без выбранного правила следует правилу по умолчанию.',
      name: 'Тип',
      nameHint: 'Например, «Обзор», «Особый пост», «Информационный пост».',
      rules: 'Текст правила',
      rulesHint: 'Markdown: заголовки, списки, **выделение**, `код`. HTML показывается как текст.',
      isDefault: 'Правило по умолчанию',
      defaultLocked: 'Это правило по умолчанию. Чтобы снять отметку, отметьте другое правило.',
      defaultBadge: 'По умолчанию',
      add: 'Добавить правило',
      edit: 'Изменить',
      makeDefault: 'Сделать по умолчанию',
      save: 'Сохранить правило',
      newTitle: 'Новое правило оформления',
      editTitle: 'Правило «{name}»',
      updated: 'Изменено {date}',
      count: 'Постов: {n}',
      empty: 'Правил пока нет',
      emptyText: 'Опишите, как пишутся посты блога, — помощники и ИИ-агенты будут писать по этому правилу.',
      emptyRules: 'Текст правила пуст.',
      deleteConfirm: 'Удалить правило «{name}»?',
      deleteText: 'Посты с этим правилом ({n}) перейдут на правило по умолчанию.',
    },
    media: {
      title: 'Медиа поста',
      hint: 'Порядок медиа — порядок публикации. Снимите отметку «К публикации» с лишних кадров — они останутся в посте запасными.',
      add: 'Добавить медиа',
      empty: 'Медиа пока нет.',
      position: '№{n}',
      remove: 'Открепить',
      left: 'Раньше',
      right: 'Позже',
      selected: 'К публикации: {n} из {total}',
      publishOf: 'Медиа №{n} к публикации',
    },
    viewer: {
      position: '{n} из {total}',
      prev: 'Предыдущее медиа',
      next: 'Следующее медиа',
      library: 'В медиатеку',
    },
    variants: {
      title: 'Текст для каналов',
      hint: 'Если вариант пустой, в канал идёт основной текст.',
      noChannels: 'В блоге пока нет каналов.',
      useMain: 'Как основной',
      save: 'Сохранить вариант',
    },
    readiness: {
      title: 'Готовность к каналам',
      ok: 'Ограничения канала соблюдены',
      caption: 'Подпись: {n} символов',
    },
    statuses: {
      title: 'Статусы постов',
      subtitle: 'Свои статусы поверх системных состояний: от состояния зависит планирование.',
      name: 'Название',
      color: 'Цвет',
      meta: 'Состояние',
      add: 'Добавить статус',
      count: 'Постов: {n}',
      deleteTitle: 'Удалить статус «{name}»',
      replaceWith: 'Перенести посты в статус',
      moveUp: 'Выше',
      moveDown: 'Ниже',
    },
  },
};

export const en: typeof ru = {
  posts: {
    meta: {
      draft: 'Not ready',
      ready: 'Ready to publish',
      published: 'Published',
      retired: 'Retired',
    },
    list: {
      title: 'Posts',
      create: 'New post',
      newTitle: 'Working title',
      newHint: 'E.g. the venue name. The post starts as a draft.',
      search: 'Search title and text',
      status: 'Status',
      allStatuses: 'All statuses',
      allOfMeta: 'All in “{meta}”',
      format: 'Formatting rule',
      allFormats: 'All rules',
      tag: 'Hashtag',
      sort: 'Sort',
      sortUpdated: 'Recently updated',
      sortCreated: 'Recently created',
      empty: 'No posts yet',
      emptyText: 'Create your first post and attach photos from the media library.',
      emptySearch: 'Nothing found',
      inQueue: 'In queue',
      planned: { one: '{n} scheduled', few: '{n} scheduled', many: '{n} scheduled', other: '{n} scheduled' },
      publishedIn: 'Published: {channels}',
      dates: {
        created: 'Created {date}',
        updated: 'Edited {date}',
        published: 'Published {date}',
        planned: 'Scheduled for {date}',
      },
      media: { one: '{n} media', few: '{n} media', many: '{n} media', other: '{n} media' },
      linkedTo: 'Linked to record',
      clearLinked: 'Clear',
    },
    editor: {
      back: '← Posts',
      title: 'Working title',
      body: 'Post text',
      bodyHint: 'Hashtags go into a separate field and are appended to the caption.',
      tags: 'Hashtags',
      tagsHint: 'Separated by spaces or commas, “#” is optional.',
      status: 'Status',
      customFields: 'Post fields',
      save: 'Save post',
      saved: 'Post saved',
      deleteConfirm: 'Delete post “{title}”?',
      unsaved: 'You have unsaved changes',
      format: 'Formatting rule',
      formatDefault: 'Default ({name})',
      formatDefaultNone: 'Default',
      formatHint: 'How to write this post’s text and hashtags.',
      notes: 'Notes',
      notesHint: 'Markdown: where facts come from, open questions. Not part of the caption.',
      preview: 'Preview',
      previewEmpty: 'Empty',
    },
    formatRules: {
      show: 'Rule “{name}”',
      showDefault: 'Rule “{name}” (default)',
      none: 'The blog has no formatting rules. The owner sets them in “Settings → Formatting rules”.',
    },
    formats: {
      title: 'Formatting rules',
      subtitle:
        'How the blog’s posts are written: text, hashtags, photo order, where facts come from. A rule is instructions and a sample for the author, helpers and AI agents, with no field placeholders. A post without a chosen rule follows the default rule.',
      name: 'Type',
      nameHint: 'For example, “Review”, “Special post”, “News post”.',
      rules: 'Rule text',
      rulesHint: 'Markdown: headings, lists, **bold**, `code`. HTML is shown as text.',
      isDefault: 'Default rule',
      defaultLocked: 'This is the default rule. To unmark it, mark another rule as the default.',
      defaultBadge: 'Default',
      add: 'Add rule',
      edit: 'Edit',
      makeDefault: 'Make default',
      save: 'Save rule',
      newTitle: 'New formatting rule',
      editTitle: 'Rule “{name}”',
      updated: 'Changed {date}',
      count: 'Posts: {n}',
      empty: 'No rules yet',
      emptyText: 'Describe how the blog’s posts are written — helpers and AI agents will follow this rule.',
      emptyRules: 'The rule text is empty.',
      deleteConfirm: 'Delete the rule “{name}”?',
      deleteText: 'Posts with this rule ({n}) will follow the default rule.',
    },
    media: {
      title: 'Post media',
      hint: 'Media order is the publishing order. Untick “To publish” on extra shots — they stay in the post as spares.',
      add: 'Add media',
      empty: 'No media yet.',
      position: '#{n}',
      remove: 'Detach',
      left: 'Earlier',
      right: 'Later',
      selected: 'To publish: {n} of {total}',
      publishOf: 'Publish media #{n}',
    },
    viewer: {
      position: '{n} of {total}',
      prev: 'Previous media',
      next: 'Next media',
      library: 'Open in media library',
    },
    variants: {
      title: 'Text per channel',
      hint: 'If a variant is empty, the main text goes to the channel.',
      noChannels: 'The blog has no channels yet.',
      useMain: 'Same as main',
      save: 'Save variant',
    },
    readiness: {
      title: 'Channel readiness',
      ok: 'Channel limits are met',
      caption: 'Caption: {n} characters',
    },
    statuses: {
      title: 'Post statuses',
      subtitle: 'Your statuses on top of system states — scheduling depends on the state.',
      name: 'Name',
      color: 'Color',
      meta: 'State',
      add: 'Add status',
      count: 'Posts: {n}',
      deleteTitle: 'Delete status “{name}”',
      replaceWith: 'Move posts to status',
      moveUp: 'Move up',
      moveDown: 'Move down',
    },
  },
};
